export enum PlCardRoutes {
  review = 'review',
}
